// autogenerated
import {AthenaeumConstants, ServiceProvider, GeoCoordinate} from "@reapptor-apps/reapptor-toolkit";

export default class FindCountryRequest {

    public geoCoordinate: GeoCoordinate | null = null;

    public readonly isFindCountryRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof FindCountryRequest) || ((from as any).isFindCountryRequest === true));
    }

    public static as(from?: object | null): FindCountryRequest | null {
        return (FindCountryRequest.is(from)) ? from as FindCountryRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(FindCountryRequest, "FindCountryRequest");